var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpparHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 225,
    viewBox: "0 0 262 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.0885 22.7946C60.5111 30.1387 14.7667 35.8001 0.140625 32.7401C0.140625 75.5804 1.65367 179.009 1.65367 197.981C1.65367 216.953 15.7754 222.716 22.8363 223.226C87.1406 223.991 220.288 225.062 238.445 223.226C256.602 221.39 261.141 205.631 261.141 197.981V0.609463C239.958 -5.51057 201.527 66.5529 171.871 61.0448C134.801 54.1598 106.81 13.6146 81.0885 22.7946Z",
    fill: "#ADB3FE",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpparHover);
export default __webpack_public_path__ + "static/media/upparHover.d09901892106c8ee1fd814f3d4d289e9.svg";
export { ForwardRef as ReactComponent };